module.exports = __webpack_public_path__ + "static/media/kick_start_image.51dbd665.png";